import * as urls from "utils/contants/urls";

import { YesOrNoDialog } from "components/shared/CustomComponents";
import {
  FilterRegisterLabel,
  Label,
  LabelHeader,
  Table,
  TableBody,
  TableColumn,
  TableHead,
  TableRow,
  ActionItem,
  Actions,
  LabelAction,

} from "components/shared/CustomComponentsStyle";

import { Creators as messageAction } from "store/ducks/messages";
import { Creators as formInputsActions } from "store/ducks/formInputs";

import {
  ButtonDefault,
  CheckBox,
  SelectFieldInput,
  MultSelect,
  ButtonSecondary,
  TextField
} from "components/shared/CustomInputs";

import { Link } from "react-router-dom";
import { Col, Row,Card,Button,CloseButton } from "react-bootstrap";
import React, { PureComponent } from "react";
import {
  cancel,

  order as orderIcon,

} from "../../../../assets/icons/icons";


import { FormattedMessage } from "react-intl";

import Load from "components/Layout/Load/Load";

import PropTypes from "prop-types";
import Tab from "components/Tab";
import { ToolTip } from "components/shared/CustomComponents";
import { connect } from "react-redux";
import { Creators as managerActions } from "store/ducks/manager";
import { Input } from "../../../../components/shared/CustomInputsStyle";
import { FlexAction, SubmitRow } from "./ProfilesStyle";
import formInputs from "../../../../store/ducks/formInputs";

const setProfileToUser = (props, idNewPerfil, userId) => {

  const { setProfilerToUser } = props;
  setProfilerToUser({idprfil: idNewPerfil,userId: userId });
}


const renderTableProfiles = (props, itens) =>
  itens.map(profiler => (
    <TableRow ta="left" key={profiler.id} onClick={() => getProfilePermissions(props, profiler.id)}>


      <TableColumn onClick={() => getProfilePermissions(props, profiler.id)}>
        <Label>{profiler.id}</Label>
      </TableColumn>
      <TableColumn onClick={() => getProfilePermissions(props, profiler.id)}>
        <Label>{profiler.nome}</Label>
      </TableColumn>

    </TableRow>
  ));

const getProfilePermissions = (props, idprofile) => {
  const { getProfilePermissionsList } = props;
  getProfilePermissionsList(idprofile);
}

const searchManagerCode = (props, codigo) => {

  const { getManagerByNameCode } = props;
    if (codigo.length>=6) {
      getManagerByNameCode({name:'', id:codigo});
    }

}

const setNovoUsuarioNoPerfil = (props, usuario, idprofile) => {

  if(usuario && usuario.length>0){
  setProfileToUser(props, idprofile, usuario[usuario.length-1].value);
  }else{
    setProfileToUser(props, null, usuario.value);
  }

}

const updateCargosPerfil = (props, idPerfil, idCargo,remover) => {

  const { updateCargosPerfilData } = props;
  updateCargosPerfilData({idPerfil, idCargo,remover});
}
const enableProfilePermission = (props, id, enabled) => {
  const { setProfilePermission } = props;
  setProfilePermission({ id, enabled });
};
const requestJobsListInput = (props) => {
  const { profilesGetPerfilJobsRequest } = props;
  profilesGetPerfilJobsRequest();
};
const enableStages = (props, id, enabled) => {
  const { setStageEnable } = props;
  setStageEnable({ id, enabled });
};
const enablePlug = (props, id, enabled) => {
  const { setPlugEnable } = props;
  setPlugEnable({ id, enabled });
};
const enableTalentos = (props, id, enabled) => {
  const { setTalentosEnable } = props;
  setTalentosEnable({ id, enabled });
};
const enableManager = (props, id, enabled) => {
  const { setManagerEnable } = props;
  setManagerEnable({ id, enabled });
};
const deletarUsuario = (props, id) => {
  const { deleteUser } = props;
  deleteUser(id, {});
};
const registerNewProfile = (props, name) => {
  const { createProfile } = props;
  createProfile({ name });
};

function renderTableProfilesPermissions(props, PermissionsProfile) {


  if (PermissionsProfile != undefined) {
    return PermissionsProfile.map(profilerPermission => (
      <TableRow ta="left" key={profilerPermission.id}>

        <TableColumn>

          <CheckBox
            type="checkbox"
            checked={profilerPermission.podeGerenciarLocal}
            onChange={() =>
              enableProfilePermission(props, profilerPermission.idPermissaoSite, !profilerPermission.podeGerenciarLocal)}
          />

        </TableColumn>
        <TableColumn>
          <Label>{profilerPermission.idPermissaoSite}</Label>
        </TableColumn>
        <TableColumn style={{ float: 'left', marginLeft: '80px' }}>
          <Label>{profilerPermission.nomeUnidade}</Label>
        </TableColumn>

      </TableRow>
    ));
  } else {
    return;
  }
};

function renderRowPermissionStage(props, idPermission, PodeEditarEtapas) {

  if (PodeEditarEtapas != undefined) {
    return <TableRow >
      <TableColumn >

        <CheckBox
          type="checkbox"
          checked={PodeEditarEtapas}
          onChange={() => enableStages(props, idPermission, !PodeEditarEtapas)}
        />

      </TableColumn>

      <TableColumn >
        <Label>Habilitar edição de etapas</Label>
      </TableColumn>
    </TableRow>;
  }
  return;
}

class Profiles extends PureComponent {
  constructor() {
    super();


    
    this.state = {
      profiles: {},
      profilepermissionsSelected: {},
      profilesList:[],
      perfilJobs:[],
      profileSelected:'',
      TabModuloSelecionada: '',
      typing: false,
      focus: 0,
      inputNewProfile: '',
      showDialogYesOrNo: false,
      idDeletar: 0,
      benefits:[],
      jobsByProfiles:[],
      Newprofile:'',
      NewprofileIncluding:false,
      placesToWorkSelected:[]
    }
    this.changeYesOrNoDialog = this.changeYesOrNoDialog.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  requestVacanciesAndSetTab = filter => {
        this.setState({TabModuloSelecionada:filter.valor});
  };
  changeYesOrNoDialog(show, id) {
    this.setState({ showDialogYesOrNo: show, idDeletar: id });
  }
  componentDidMount() {
    const { getProfilesList } = this.props;
    getProfilesList();
    const { getUsersList } = this.props;    

    getUsersList();

    const { requestInputValues } = this.props; 
    requestInputValues(["placeOfWork"]);

    this.setState({
      columns: [
        {
          name: "Talentos",
          focus: this.state.focus === 0,
          action: this.requestVacanciesAndSetTab,
          filter: { campo: "status", valor: "Talentos", NumeroPagina: 1 }
        },
        {
          name: "Plug",
          focus: this.state.focus === 1,
          action: this.requestVacanciesAndSetTab,
          filter: { campo: "status", valor: "Plug", NumeroPagina: 2 },
        },
        {
          name: "Mova",
          focus: this.state.focus === 2,
          action: this.requestVacanciesAndSetTab,
          filter: { campo: "status", valor: "Mova", NumeroPagina: 3 },
        },
        {
          name: "Gerais",
          focus: this.state.focus === 2,
          action: this.requestVacanciesAndSetTab,
          filter: { campo: "status", valor: "Gerais", NumeroPagina: 4 },
        }
      ],
      profilepermissionsSelected:
      {
        permissaoUnidadeList: []
      }
    });

  }

  static getDerivedStateFromProps(nextProps, state) {

    if (nextProps.formInputs != undefined) {
      const formInputs = nextProps.formInputs;
      

      if (state.formInputs !== formInputs) {
        return { ...state, formInputs: formInputs };
      }
    }

    const profilesList = nextProps.profiles.profilesList;

    if (nextProps.profiles.profilesList != undefined) {
      const profilesList = nextProps.profiles.profilesList;

      const perfilJobs = nextProps.profiles.perfilJobs?.data;


      if (state.profiles.profilesList !== profilesList) {
        return { ...state, profilesList: profilesList, perfilJobs: perfilJobs };
      }
    }

    if (nextProps.profiles.perfilJobs != undefined) {
      const idPerfil = nextProps.profiles.perfilJobs?.idPerfil;

      if (state.profileSelected !== idPerfil) {
        return { ...state, profileSelected: idPerfil };
      }
    }


    if (nextProps.profiles.profilepermissionsSelected != undefined && nextProps.profiles.isLoading == false) {
      const profilepermissionsSelected = nextProps.profiles.profilepermissionsSelected;
      if (state.profilepermissionsSelected !== profilepermissionsSelected) {

        return { ...state, profilepermissionsSelected: profilepermissionsSelected };
      }

    } else
      return null;

  }

  renderIcon(key) {
    const { order } = this.state;
    return orderIcon({
      style: { transform: `rotate(${order !== key ? "0" : "180deg"})` }
    });
  }
renderTableUsers (TabModuloSelecionada,profileSelected){


  
  switch(TabModuloSelecionada){
    case "Talentos":

      return (

<Card>
  <Card.Header as="h5">Vagas</Card.Header>
  <Card.Body>
    <Card.Text>
    <CheckBox        
        type="checkbox" />  Permitir criação de vagas.
    </Card.Text>
    <Card.Text>
    <CheckBox        
        type="checkbox" />  Permitir visualização de Dash gerencial.
    </Card.Text>
    <Card.Text>
    <CheckBox        
        type="checkbox" />  Permitir visualização de Dash analítica.
    </Card.Text>

    <Card.Text>
    <CheckBox        
        type="checkbox" />  Permitir criação de etapas.
    </Card.Text>
  </Card.Body>
</Card>
        
          )
    
    case "Plug":

      return (
<>
<Card>
  <Card.Header as="h5">Documentos</Card.Header>
  <Card.Body>
    <Card.Text>
    <CheckBox        
        type="checkbox" />  Permitir alteração de status.
    </Card.Text>
    <Card.Text>
    <CheckBox        
        type="checkbox" />  Permitir visualização de documentos
    </Card.Text>
    <Card.Text>
    <CheckBox        
        type="checkbox" />  Permitir reprovação de candidatura.
    </Card.Text>

  </Card.Body>
</Card>
<Card style={{marginTop: '16px'}}>
  <Card.Header as="h5">Contratos</Card.Header>
  <Card.Body>
    <Card.Text>
    <CheckBox        
        type="checkbox" />  Permitir alteração de status.
    </Card.Text>
    <Card.Text>
    <CheckBox        
        type="checkbox" />  Permitir visualização de contratos
    </Card.Text>
    <Card.Text>
    <CheckBox        
        type="checkbox" />  Permitir habilitação de assinatura de contrato.
    </Card.Text>

  </Card.Body>
</Card>
</>
        
          )

    case "Mova":

      return (

        <Card style={{marginTop: '16px'}}>
  <Card.Header as="h5">Contratos</Card.Header>
  <Card.Body>
    <Card.Text>
    <CheckBox        
        type="checkbox" />  Permitir abertura de vagas.
    </Card.Text>
    <Card.Text>
    <CheckBox        
        type="checkbox" />  Permitir visualização de todos os processos de contração.
    </Card.Text>
    <Card.Text>
    <CheckBox        
        type="checkbox" />  Permitir visualização de contratos.
    </Card.Text>

  </Card.Body>
</Card>
          )
        
          

          case "Gerais":

            return (
              <div>
      <div>
              <Card style={{marginTop: '16px'}}>
                <Card.Header as="h5">Usuários</Card.Header>
        <Card.Body>
        <MultSelect

            name={"Gerais"}
            options={this.state.formInputs.managerName.map(item => ({
              value: item.managerCode,
              label: item.managerCode+ "-"+ item.label 
            }))}
            defaultValue={this.state.usuarios}
            onChange={e => {  this.setState({usuarios: e ? e.map( item=>item.value): []  });   setNovoUsuarioNoPerfil(this.props,e,this.state.profileSelected);}}
            isMulti
            onInputChange={e =>searchManagerCode(this.props,e)}
            isDisabled={!this.state.profileSelected}

            />
      
        </Card.Body>
      </Card>
      </div>
      <div>
        {console.log(this.state.profilesList?.filter(k => k.id == this.state.profileSelected)[0].locaisUnidadeHabilitados || '0')}
              <Card style={{marginTop: '16px'}}>
                <Card.Header as="h5">Filiais/Sites</Card.Header>
        <Card.Body>
        <MultSelect

            name={"Filiais"}
            options={this.state.formInputs.placeOfWork.map(item => ({
              label: item.nome,
              value: item.id
            }))}
            value={this.state.profilesList?.filter(k => k.id == this.state.profileSelected)[0].locaisUnidadeHabilitados?.map(e => ({
              value: e.id,
              label: e.nome,
            }))}


            defaultValue={this.state.profileSelected}
              onChange={e =>
                this.setState({
                   placesToWorkSelected: e
                    ? e.map(k => {
                      return k.value;
                    })
                    : []
                })
              }
            isMulti
            isDisabled={!this.state.profileSelected}

            />
      
        </Card.Body>
      </Card>
      </div>

      </div>
      
      
                )
              
  }

}


updateCargo(selecionados){
  var idCargo ;
  var remover = false;
  var listaAnterior = this.state.perfilJobs.filter(k => k.idPerfilAcesso == this.state.profileSelected).map(e => ({
    id: e.id
  }));


  if(!selecionados)
{
  var idCargo = this.state.perfilJobs.filter(k => k.idPerfilAcesso == this.state.profileSelected)[0].id;
  remover = true;
}else{
  var listaAtual = selecionados.map(e => ({
    id: e.value
  }));;

  if(selecionados.length > this.state.profilesList.filter(k => k.idPerfilAcesso == this.state.profileSelected).length){
    var idCargo = selecionados[selecionados.length-1].value;

  }else{
    var idCargo = listaAnterior.filter(o1 => listaAtual.filter(o2 => o2.id === o1.id).length === 0)[0].id;
    remover = true;
  }
}



  updateCargosPerfil(this.props,this.state.profileSelected, idCargo,remover);

}
    inicializaPermissoes(){
      if(!this.state.TabModuloSelecionada){
      this.setState({TabModuloSelecionada:"Talentos"});  
      }
    }


  loadTabOption() {

    return (
        <React.Fragment>
          <Row>           
          <Col md={11}>
            <SelectFieldInput
              label={"Selecione um perfil"}
              items={this.state.profilesList}   
              value={this.state.profileSelected}
              onChange={e =>{ this.setState({profileSelected:e.target.value}); requestJobsListInput(this.props);   this.inicializaPermissoes();        }}
            
            />
            </Col>
            <Col md={1}>
            <Button variant="success" onClick={e=>{ this.setState({NewprofileIncluding: !this.state.NewprofileIncluding}); this.setState({Newprofile: ''})}} style={{marginTop: '17px'}}>{!this.state.NewprofileIncluding? "+":"X"}</Button>
            </Col>
          </Row>
          <Row style={!this.state.NewprofileIncluding? {display:'none'}:null}>           
          <Col md={10}>
          <TextField
                  value={this.state.Newprofile}
                  onChange={e =>  this.setState({Newprofile: e.target.value }) }
                  label={"Novo perfil"}
                />
            </Col>
            <Col md={2} style={{textAlign: 'right'}}>
            <Button disabled={!this.state.Newprofile} variant="success" style={{marginTop: '17px', marginLeft:'-10px'}} onClick={()=> registerNewProfile(this.props,this.state.Newprofile)}>Registrar</Button>
            </Col>
          </Row>
          
 
          <MultSelect

              name={"Cargos"}
              value={this.state.perfilJobs?.filter(k => k.idPerfilAcesso == this.state.profileSelected).map(e => ({
                value: e.id,
                label: e.funcao,
              }))}
              options={this.state.perfilJobs?.map(item => ({
                value: item.id,
                label: item.funcao,
                disabled: true
              }))}
              label={"Cargos"}
              isMulti
              onChange={e => this.updateCargo(e)}
              isDisabled={!this.state.profileSelected}

            />
          <Tab columns={this.state.columns}>
            <React.Fragment>
            {this.state.profileSelected && this.renderTableUsers(this.state.TabModuloSelecionada, this.state.profileSelected)}

            </React.Fragment>


          </Tab>

        </React.Fragment>
    )
        

  }

  handleChange(event) {
    this.setState({ inputNewProfile: event.target.value });
  }

  render() {


    const { profiles } = this.props;
    if (profiles.isLoading) return <Load isLoading={profiles.isLoading} />;




      return (

        this.loadTabOption()

      );

  }
}


const mapDispatchToProps = dispatch => ({
  getProfilesList: payload => dispatch(managerActions.profilesRequest(payload)),
  messagePublication: messages =>  dispatch(messageAction.messagePublication(messages)),
  updateCargosPerfilData : (idPerfil, idCargo,remover) => dispatch(managerActions.profilesJobsUpdateRequest(idPerfil, idCargo,remover)),
  getUsersList: payload => dispatch(managerActions.profilesUsersRequest(payload)),
  setProfilerToUser: (idPerfil, IdUser, payload) => dispatch(managerActions.profilesUserUpdateRequest(idPerfil, IdUser, payload)),
  getProfilePermissionsList: (id, payload) => dispatch(managerActions.profilesPermissionsRequest(id, payload)),
  setProfilePermission: (id, enabled, payload) => dispatch(managerActions.profilesEditPermissionsRequest(id, enabled, payload)),
  createProfile: (nome, payload) => dispatch(managerActions.profilesCreateRequest(nome, payload)),
  setStageEnable: (id, enabled, payload) => dispatch(managerActions.profilesEnableStageRequest(id, enabled, payload)),
  setPlugEnable: (id, enabled, payload) => dispatch(managerActions.profilesEnablePlugRequest(id, enabled, payload)),
  setTalentosEnable: (id, enabled, payload) => dispatch(managerActions.profilesEnableTalentosRequest(id, enabled, payload)),
  deleteUser: (id) => dispatch(managerActions.userDeleteRequest(id)),
  setManagerEnable: (id, enabled, payload) => dispatch(managerActions.profilesEnableManagerRequest(id, enabled, payload)),
  profilesGetPerfilJobsRequest: payload => dispatch(managerActions.profilesGetPerfilJobsRequest(payload)),
  getManagerByNameCode: id => dispatch(formInputsActions.formInputsSearchByNameRequest(id)),
  requestInputValues: inputs =>  dispatch(formInputsActions.formInputsRequest(inputs)),

});


function mapStateToProps(state) {

  var Profiles;
  var idPerfil;
  if(state.formInputs.jobsByProfiles){
    var ddd = "dd";
  }
  if(state.profiles){
    Profiles = "dd";
  }
  if(state.profiles && state.profiles.jobsByProfiles &&  state.profiles.jobsByProfiles.idPerfil){
    idPerfil = parseInt(state.profiles.jobsByProfiles.idPerfil) ;
  }
  return { profiles: state.profiles,profileSelected:idPerfil,formInputs:state.formInputs}
}



Profiles.propTypes = {
  profiles: PropTypes.object,
  profileSelected:PropTypes.object,
  users: PropTypes.object,
  getProfilesList: PropTypes.func,
  setProfilerToUser: PropTypes.func,
  getProfilePermissionsList: PropTypes.func,
  createProfile: PropTypes.func,
  setProfilePermission: PropTypes.func,
  setStageEnable: PropTypes.func,
  updateCargosPerfilData: PropTypes.func,
  formInputs: PropTypes.object
};

Profiles.defaultProps = {
  profiles: {},
  profileSelected:{},
  jobsByProfiles:[],
  users: {},
  requestInputValues : () => { },
  getProfilesList: () => { },
  updateCargosPerfilData: () => { },
  getUsersList: () => { },
  setProfilerToUser: () => { },
  getProfilePermissionsList: () => { },
  setProfilePermission: () => { },
  createProfile: () => { },
  setStageEnable: () => { },
  profilesGetPerfilJobsRequest: () => { }
};


export default connect(mapStateToProps, mapDispatchToProps)(Profiles);
